/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для страницы торговой марки "Тундра"
   */
  app.TundraView = app.ArtUzorView.extend({
    el: '[data-jsmodel = "tundra"]',

    events: {
      'click .js-scroll-link': 'scrollToIdBlock',
      'click .history-date': 'toggleInfoBlocks',
      'click .control-arrows.arrow-up': 'newsScrollUp',
      'click .control-arrows.arrow-down': 'newsScrollDown',
      'click .videobl': 'toggleMainVideo',
    },

    run: function () {
      var that = this,
        src = this.$('.video-wrapper video').attr('src');
      this.activePoints();
      $(document).on('scroll', function () {
        that.activePoints();
      });
      this.addOwlCarousel();
      this.videoView = new app.BaseVideoView({'el': this.$('.video-wrapper'), templateName: '#video-template'});
      this.videoView.render(src);
    },

    /**
     * Добавление карусели
     */
    addOwlCarousel: function () {
      this.videoCarousel = this.$el.find('.other-video');
      var owlConfig = {
        nav: true,
        dots: false,
        items: 2,
        slideBy: 2,
      };
      if (this.$('.videobl').length <= 2) {
        owlConfig.nav = false;
      }
      this.videoCarousel.owlCarousel(owlConfig);
    },

    activePoints: function () {
      $('.slide-tm-js').each(function () {
        var thisId = $(this).attr('id'),
          top = $(this).offset().top,
          bottom = top + $(this).outerHeight();

        if ($(window).scrollTop() >= top && $(window).scrollTop() <= bottom) {
          $('.float_menu li').removeClass('active');
          $('.float_menu a[data-id=' + thisId + ']').parent().addClass('active');
        }
      });
    },

     /**
     * Переключение блоков с информацией в разделе истории.
     * @param e
     */
    toggleInfoBlocks: function (e) {
      if (!$(e.currentTarget).hasClass('active')) {
        var selector = $(e.currentTarget).data('id'),
          that = this;
        this.$('.history-text-block').animate({'opacity': 0}, 400, 'swing', function () {
          that.$('.history-text-block').removeClass('active');
          that.$('.history-date').removeClass('active');
          that.$(e.currentTarget).addClass('active');
          that.$('#' + selector).addClass('active');
          that.$('.history-text-block').animate({'opacity': 1});
        });
      }
    },
  });
})(jQuery);

}.call(window));